module.exports = __webpack_public_path__ + "static/img/s6.31280754.png";